var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppHeader'),_c('div',{staticClass:"main"},[_c('UserTaskList',{attrs:{"listTasksScreen":"true"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }